import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/category/training', label: '体育培训' },
  { to: '/category/events', label: '赛事组织' },
  { to: '/category/fitness', label: '运动健身' },
  { to: '/category/venues', label: '场馆预约' },
  { to: '/category/youth', label: '青少年训练' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-basketball-line text-background-50 text-lg"></i>
          </div>
          <span className={`font-heading text-xl font-bold tracking-wide ${
            scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
          }`}>
            云开体育
          </span>
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname === link.to
                  ? scrolled || !isHome
                    ? 'text-primary-600 bg-primary-100'
                    : 'text-accent-400 bg-background-50/20'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/20'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/category/membership"
            className={`px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all cursor-pointer ${
              scrolled || !isHome
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-accent-500 text-background-50 hover:bg-accent-600'
            }`}
          >
            加入会员
          </Link>
        </div>

        <button
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="切换菜单"
        >
          <i className={`text-xl ${scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'} ${
            mobileOpen ? 'ri-close-line' : 'ri-menu-line'
          }`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="lg:hidden bg-background-50 border-b border-background-200/70 px-4 py-3 flex flex-col gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-3 py-2.5 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname === link.to
                  ? 'text-primary-600 bg-primary-100'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/category/membership"
            className="mt-2 px-5 py-2.5 rounded-full text-sm font-semibold bg-primary-500 text-background-50 text-center whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            加入会员
          </Link>
        </div>
      )}
    </header>
  );
}